import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import ButtonClose from '../../../ButtonClose';
import { IconSizes } from '../../../../constants';
import './ParticipantsListHeader.scss';
const ParticipantsListHeader = ({ amount, closeHandle }) => {
    return (<div className="ml-participants-list-header">
      <div className="ml-participants-list-header__title">
        <FormattedMessage id="video-chat.mobile.participants{amount}" values={{ amount }}/>
      </div>
      <div className="ml-participants-list-header__close">
        <ButtonClose size={IconSizes.Medium} clickHandle={closeHandle}/>
      </div>
    </div>);
};
export default memo(ParticipantsListHeader);
